import { types } from "../types";

const DeviceAction = {
   deviceList: () => {
      return { type: types.DEVICE_LIST };
   },

   createDevice: () => {
      return { type: types.CREATE_DEVICE };
   },

   updateDevice: () => {
      return { type: types.UPDATE_DEVICE };
   },

   deleteDevice: () => {
      return { type: types.DELETE_DEVICE };
   },

   currentDevice: (device) => {
      return { type: types.Current_Device ,device};
   },

   getAllDeviceListSuccess: (deviceList) => {
      return { type: types.DEVICE_LIST_SUCCESS, deviceList };
   },

   deviceListCm: () => {
      return { type: types.DEVICE_LIST_CM };
   },

   getAllDeviceListCMSuccess: () => {
      return { type: types.DEVICE_CM_LIST_SUCCESS };
   },

   setDeviceBreadcrumbs: (breadCrumbList) => {
      return { type: types.SETDEVICE_BREADCRUMB_LIST, breadCrumbList };
   },

   getTagReferenceList: () => {
      return { type: types.GET_TAGREFERENCE_LIST };
   },

   getTagReferenceListSuccess: () => {
      return { type: types.GET_TAGREFERENCE_LIST_SUCCESS };
   }
};

export default DeviceAction;